import { get, getAll, getById } from "@/utilities/querySelector";

jQuery( function( $ ) {
    if ( !document.body.classList.contains( 'single-product' ) ) return;
    const tabs = get( '.woocommerce-tabs' );
    if ( !tabs ) return;

    const mediaWatcher = window.matchMedia( '(min-width: 640px)' );

    setTabsState();
    mediaWatcher.addEventListener( 'change', setTabsState );

    function setTabsState() {
        const tabTriggers = getAll( '.wc-tabs .wc-tabs-link' );
        const isLarge = mediaWatcher.matches;
        const currentState = tabs.classList.contains( 'woocommerce-tabs--mobile' ) ? 'mobile' : 'desktop';

        if ( !isLarge && currentState === 'desktop' ) {
            tabTriggers.forEach( trigger => {
                const targetID = trigger.getAttribute( 'href' )?.replace( '#', '' );
                const panel = getById( targetID );
                trigger.after( panel );
                tabs?.classList.add( 'woocommerce-tabs--mobile' );
            } );
        } else if ( isLarge && currentState === 'mobile' ) {
            tabTriggers.forEach( trigger => {
                const targetID = trigger.getAttribute( 'href' )?.replace( '#', '' );
                const panel = getById( targetID );
                tabs?.appendChild( panel );
                tabs?.classList.remove( 'woocommerce-tabs--mobile' );
            } );
        }
    }
} );
